import React from 'react';
import useBundleTranslation from 'i18n';

interface ChartsLayoutIconProps {
    width?: number;
    height?: number;
    className?: string;
}

export default function ChartsLayoutIcon({ width = 360, height = 216, className }: ChartsLayoutIconProps) {
    const { t } = useBundleTranslation('form');

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 360 216"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect width="360" height="216" rx="4" fill="#00B4FF" fillOpacity="0.04" />
            <rect x="0.5" y="0.5" width="359" height="215" rx="3.5" stroke="#00B4FF" strokeOpacity="0.4" />

            {/* Hero Section */}
            <rect
                x="16.5"
                y="16.5"
                width="327"
                height="23"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="24" y="31.2727">
                    {t('builder_layouts.hero_section')}
                </tspan>
            </text>

            {/* Chart 1 */}
            <rect
                x="16.5"
                y="56.5"
                width="155"
                height="63"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="77" y="92.2727">
                    {t('builder_layouts.chart_1')}
                </tspan>
            </text>

            {/* Chart 2 */}
            <rect
                x="188.5"
                y="56.5"
                width="155"
                height="63"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="248" y="92.2727">
                    {t('builder_layouts.chart_2')}
                </tspan>
            </text>

            {/* Chart 3 */}
            <rect
                x="16.5"
                y="136.5"
                width="155"
                height="63"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="76" y="172.273">
                    {t('builder_layouts.chart_3')}
                </tspan>
            </text>

            {/* Chart 4 */}
            <rect
                x="188.5"
                y="136.5"
                width="155"
                height="63"
                rx="3.5"
                fill="#00B4FF"
                fillOpacity="0.12"
                stroke="#00B4FF"
            />
            <text
                fill="#00B4FF"
                fillOpacity="0.56"
                xmlSpace="preserve"
                style={{ whiteSpace: 'pre' }}
                fontFamily="Inter"
                fontSize="10"
                letterSpacing="0px"
            >
                <tspan x="248" y="172.273">
                    {t('builder_layouts.chart_4')}
                </tspan>
            </text>
        </svg>
    );
}
